export default "__VITE_ASSET__CNfGKQS$__"